import { Checkbox } from "@mui/material";
import React from "react";
import { CustomDialog, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";

export default function ConfirmDeleteDialog({
	deleteContent,
	isFolder,
	onClose,
	onConfirm,
	onSetDeleteContent,
	open,
	text,
	textSubDir,
}) {
	const handleConfirm = () => onConfirm();

	return (
		<>
			<CustomDialog
				iconColor="var(--red-500)"
				iconModel={icon.faExclamationTriangle}
				open={open}
				submitColor="destructive"
				submitLabel={translate("common:btn.confirm")}
				subTitle={
					<>
						<div>{text}</div>
						{isFolder && (
							<div>
								<Checkbox checked={deleteContent} color="primary" onChange={onSetDeleteContent} />
								{textSubDir}
							</div>
						)}
					</>
				}
				title={translate("document-center.confirm-delete.title")}
				onClose={onClose}
				onSubmit={handleConfirm}
			/>
		</>
	);
}
